import { BorderRadius, BorderWidth, Color, HorizontalFlex, Space, VerticalFlex } from "@enxcs/dap-ui-stratos";
import styled from "styled-components";

export const ExportVerticalFlexButton = styled(VerticalFlex)`
  border: ${BorderWidth.V1} solid ${Color.Neutral.V30};
  border-radius: ${BorderRadius.V8};
  cursor: pointer;

  &:hover {
    background-color: ${Color.Neutral.V20};
  }
`;

export const CustomExportOptionsLegalNotice = styled(HorizontalFlex)`
  background-color: ${Color.Blue.V20};
  border-radius: ${BorderRadius.V8};
  gap: ${Space.V8};
  margin-top: ${Space.V16};
  padding: ${Space.V16} !important;
  width: calc(100% - 32px); /* Full width minus padding */
`;
